export function getViteAppEsrApiUrl(): string {
  return import.meta.env.VITE_ESR_API_URL;
}
